<script setup lang="ts">
import { useCarousel } from './useCarousel'
import { cn } from '../../../lib/utils'
import { Button } from '../button'
import StepCounterArrow from "../../../icons/StepCounterArrow.vue";

const props = defineProps<{
  ariaLabel?: string;
}>()

const { orientation, canScrollNext, scrollNext } = useCarousel()
</script>

<template>
  <Button
    :disabled="!canScrollNext"
    :class="cn(
      orientation === 'horizontal' ? '' : 'rotate-90',
      { 'opacity-30': !canScrollNext },
    )"
    variant="icon"
    :aria-label="props.ariaLabel ?? 'Next slide'"
    @click="scrollNext"
  >
    <slot>
      <StepCounterArrow class="h-32 w-32" />
    </slot>
  </Button>
</template>
